module.exports = __webpack_public_path__ + "static/sushi-in-a-bowl-41b890ae48e687303f10f391a00ab9eb.png";